import { get } from '@ember/object';
import changesetGet from 'ember-changeset/helpers/changeset-get';
import ScaleSurveyEditionFormComponent from 'parog-web/components/abstract/scale-survey-edition-form';
import Provider from 'parog-web/components/forc/provider';
import QuestionItem from 'parog-web/components/scale-surveys/fast-edition-form/question-item';
import FastDeclaredJournalEvent from 'parog-web/models/fast-declared-journal-event';
import fastScoreDescription from 'parog-web/utils/fast-score-description';
import TwoButtonTabs from 'ui-kit/components/two-button-tabs';

export default class FastEditionFormComponent extends ScaleSurveyEditionFormComponent {
  static override forcDisplayName = 'Functional Assessment Staging (FAST)';
  static override fullComponentId = 'scale-surveys/fast-edition-form';
  static override journalEventClass = FastDeclaredJournalEvent;

  override get maximalScore() {
    return 72;
  }

  override get numberOfItems() {
    return 24;
  }

  override _computeScore(payload) {
    const number = this.questionIds.reduce(
      (total, index) => total + parseInt(get(payload, index)),
      0
    );

    return {
      number,
      description: fastScoreDescription(number)
    };
  }

  <template>
    <Provider @forcComponent={{this}}>
      <:content as |Form|>
        <TwoButtonTabs
          class='large'
          @selected={{if
            (changesetGet this.changeset 'isTotalScoreFilled')
            'second'
            'first'
          }}
          @onClick={{this.onTabButtonClicked}}
        >
          <:firstButton>Répondre aux questions</:firstButton>
          <:secondButton>Renseigner le score</:secondButton>

          <:firstTab>
            <div class='field'>
              <Form.Date
                @labelName='Date à laquelle le questionnaire a été renseigné'
                @propertyName='occurredAt'
              />
            </div>

            <h4>A quel degré le patient a-t-il des difficultés à fonctionner
              dans les situations qui suivent ?</h4>

            <p>
              Posez des questions au patient sur ses difficultés de comportement
              et donnez une note en fonction de l'échelle suivante:<br />
              (0): aucune difficulté, (1): légère difficulté, (2): difficulté
              modérée, (3): grave difficulté.
            </p>

            <h4>AUTONOMIE</h4>
            <QuestionItem
              @name="Être responsable d'une famille"
              @propertyName='0'
              @form={{Form}}
            />
            <QuestionItem
              @name='Vivre de manière indépendante'
              @propertyName='1'
              @form={{Form}}
            />
            <QuestionItem
              @name='Faire les courses'
              @propertyName='2'
              @form={{Form}}
            />
            <QuestionItem
              @name='Prendre soin de soi (aspect physique, hygiène)'
              @propertyName='3'
              @form={{Form}}
            />

            <h4>COMPORTEMENT PROFESSIONNEL</h4>
            <QuestionItem
              @name='Conserver un emploi rémunéré'
              @propertyName='4'
              @form={{Form}}
            />
            <QuestionItem
              @name='Accomplir des tâches aussi rapidement que nécessaire'
              @propertyName='5'
              @form={{Form}}
            />
            <QuestionItem
              @name='Travailler dans le domaine dans lequel on a été formé'
              @propertyName='6'
              @form={{Form}}
            />
            <QuestionItem
              @name='Rémunération professionnelle'
              @propertyName='7'
              @form={{Form}}
            />
            <QuestionItem
              @name='Gérer la charge de travail prévue'
              @propertyName='8'
              @form={{Form}}
            />

            <h4>FONCTION COGNITIVE</h4>
            <QuestionItem
              @name='Capacité à se concentrer sur un livre, un film'
              @propertyName='9'
              @form={{Form}}
            />
            <QuestionItem
              @name='Capacité à faire du calcul mental'
              @propertyName='10'
              @form={{Form}}
            />
            <QuestionItem
              @name='Capacité à résoudre un problème de manière adéquate'
              @propertyName='11'
              @form={{Form}}
            />
            <QuestionItem
              @name='Capacité à se rappeler de nouveaux noms'
              @propertyName='12'
              @form={{Form}}
            />
            <QuestionItem
              @name='Capacité à apprendre des choses nouvelles'
              @propertyName='13'
              @form={{Form}}
            />

            <h4>QUESTIONS FINANCIÈRES</h4>
            <QuestionItem
              @name='Gestion de son propre argent'
              @propertyName='14'
              @form={{Form}}
            />
            <QuestionItem
              @name="Dépenser de l'argent de manière raisonnée"
              @propertyName='15'
              @form={{Form}}
            />

            <h4>RELATIONS INTERPERSONNELLES</h4>
            <QuestionItem
              @name='Entretenir une ou des amitiés'
              @propertyName='16'
              @form={{Form}}
            />
            <QuestionItem
              @name='Participer à des activités sociales'
              @propertyName='17'
              @form={{Form}}
            />
            <QuestionItem
              @name='Avoir de bonnes relations avec son entourage'
              @propertyName='18'
              @form={{Form}}
            />
            <QuestionItem
              @name='Vivre avec sa famille'
              @propertyName='19'
              @form={{Form}}
            />
            <QuestionItem
              @name='Avoir des relations sexuelles satisfaisantes'
              @propertyName='20'
              @form={{Form}}
            />
            <QuestionItem
              @name='Être capable de défendre ses intérêts'
              @propertyName='21'
              @form={{Form}}
            />

            <h4>LOISIRS</h4>
            <QuestionItem
              @name="Faire de l'exercice ou participer à une activité sportive"
              @propertyName='22'
              @form={{Form}}
            />
            <QuestionItem
              @name="Avoir des passe-temps ou des centres d'intérêts"
              @propertyName='23'
              @form={{Form}}
            />

            <div class='ui message' data-test-score>
              <strong>Score : </strong>
              {{#if this.isChangesetValid}}
                {{this.score.number}}
                –
                {{this.score.description}}
              {{else}}
                veuillez remplir tous les champs afin d'obtenir le score.
              {{/if}}
            </div>
          </:firstTab>

          <:secondTab>
            <div class='field'>
              <Form.Date
                @labelName='Date à laquelle le questionnaire a été renseigné'
                @propertyName='occurredAt'
              />
            </div>
            <div class='field'>
              <Form.NumberInput
                @labelName='Score total'
                @propertyName='total'
                @type='integer'
              />
            </div>
          </:secondTab>
        </TwoButtonTabs>
      </:content>
    </Provider>
  </template>
}
